import React from "react";
import HomeContent from "../components/Home/home";
import NavbarContent from "../components/Navbar/navbar";

export default function Home(){
       return(
              <>
              <NavbarContent/>
              <HomeContent/>
              </>
       )
}